function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 80,
  rx: 12,
  fill: "#DEEFFF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_diiiisddssdsd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.2427 26.2813C20.4853 26.6293 20 27.3864 20 28.2198V37.0132C20 42.2481 21.7206 47.4838 24.8971 51.6447C28.5535 56.4343 36.2667 62.0523 39.7333 62.0523C42.9333 62.0523 50.9132 56.4343 54.5695 51.6447C57.7461 47.4838 59.4667 42.2481 59.4667 37.0132V28.2198C59.4667 27.3864 58.9813 26.6293 58.224 26.2813L40.624 18.1948C40.0586 17.9351 39.408 17.9351 38.8427 18.1948L21.2427 26.2813Z",
  fill: "#0047FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2427 26.2813C20.4853 26.6293 20 27.3864 20 28.2198V37.0132C20 42.2481 21.7206 47.4838 24.8971 51.6447C28.5535 56.4343 36.2667 62.0523 39.7333 62.0523C42.9333 62.0523 50.9132 56.4343 54.5695 51.6447C57.7461 47.4838 59.4667 42.2481 59.4667 37.0132V28.2198C59.4667 27.3864 58.9813 26.6293 58.224 26.2813L40.624 18.1948C40.0586 17.9351 39.408 17.9351 38.8427 18.1948L21.2427 26.2813Z",
  fill: "url(#paint0_linearfasdfsfasfd)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2427 26.2813C20.4853 26.6293 20 27.3864 20 28.2198V37.0132C20 42.2481 21.7206 47.4838 24.8971 51.6447C28.5535 56.4343 36.2667 62.0523 39.7333 62.0523C42.9333 62.0523 50.9132 56.4343 54.5695 51.6447C57.7461 47.4838 59.4667 42.2481 59.4667 37.0132V28.2198C59.4667 27.3864 58.9813 26.6293 58.224 26.2813L40.624 18.1948C40.0586 17.9351 39.408 17.9351 38.8427 18.1948L21.2427 26.2813Z",
  fill: "url(#paint1_linearafasdfasds)",
  fillOpacity: 0.7
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_isdsdadas)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.865 33.6519C51.6749 34.4618 51.6749 35.7748 50.865 36.5847L40.2965 47.1532C39.4634 47.9863 38.1126 47.9863 37.2795 47.1532L30.5657 40.4395C29.7377 39.6115 29.7376 38.269 30.5657 37.4409C31.3937 36.6129 32.7362 36.6129 33.5642 37.4409L38.8538 42.7305L47.9322 33.6519C48.7421 32.8421 50.0551 32.8421 50.865 33.6519Z",
  fill: "#F0F7FF"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_diiiisddssdsd",
  x: 7.28477,
  y: 5.16172,
  width: 64.8971,
  height: 78.1646,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8.55885
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.35762
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.639132 0 0 0 0 0.75191 0 0 0 0 0.970833 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -12.8383
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 28.6093
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.575 0 0 0 0 0.847 0 0 0 0 1 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -9.53643
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.13245
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow",
  result: "effect3_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.35762
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.45033
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_innerShadow",
  result: "effect4_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.06667
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.6
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.462745 0 0 0 0 0.678431 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_innerShadow",
  result: "effect5_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_isdsdadas",
  x: 29.9453,
  y: 31.8708,
  width: 21.5278,
  height: 15.9072,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -1.17367
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.782446
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.2 0 0 0 0 0.439216 0 0 0 0 1 0 0 0 0.63 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linearfasdfsfasfd",
  x1: 40.6754,
  y1: 0.68899,
  x2: 40.6754,
  y2: 51.4358,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00520833,
  stopColor: "white",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0851933,
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.336988,
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.660917,
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linearafasdfasds",
  x1: 40.6439,
  y1: 16.7189,
  x2: 40.6439,
  y2: 61.3548,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#526EFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgIconMore3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 84,
    viewBox: "0 0 80 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore3);
export default __webpack_public_path__ + "static/media/icon_more_3.34998382.svg";
export { ForwardRef as ReactComponent };